import React from 'react'
import BybShipDelivery from './BybShipDelivery/BybShipDelivery'
import PageSeo from '../Common/Seo/PageSeo'

const ShippingPage = () => {
  return (
    <div>
        <PageSeo
          title="Shipping and Delivery | Brew Your Brand"
          description="View Brew Your Brand shipping and delivery details for brand resources, digital products, and related purchases."
          canonical="/shipping-delivery"
          ogTitle="Shipping and Delivery | Brew Your Brand"
        />
        <BybShipDelivery/>
    </div>
  )
}

export default ShippingPage
